import { useCallback, useState } from "react";

import { ResponseAnswer } from "~/components/database/detail/database-content/types";
import { useGraphqlClient } from "~/lib/client/hooks/useGraphqlClient";
import { SpecialWelcomeSaihateContentQuery } from "~/lib/graphql/client";
import { useAppContext } from "~/pages/_app";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

enum ModalContentStep {
  EDITOR = "EDITOR",
  CONFIRM = "CONFIRM",
  SUCCESS = "SUCCESS",
}

const useModalContentStep = () => {
  const [modalContentStep, setModalContentStep] = useState<ModalContentStep>(
    ModalContentStep.EDITOR
  );

  const setModalContentStepToEditor = () =>
    setModalContentStep(ModalContentStep.EDITOR);
  const setModalContentStepToConfirm = () =>
    setModalContentStep(ModalContentStep.CONFIRM);
  const setModalContentStepToSuccess = () =>
    setModalContentStep(ModalContentStep.SUCCESS);

  return {
    modalContentStep,
    setModalContentStepToEditor,
    setModalContentStepToConfirm,
    setModalContentStepToSuccess,
  };
};

const useCreateResponse = ({
  form,
  responseAnswers,
}: {
  form:
    | DatabaseDetailPageProps["form"]
    | SpecialWelcomeSaihateContentQuery["forms"][number];
  responseAnswers: ResponseAnswer[];
}) => {
  const { currentUser } = useAppContext();
  const client = useGraphqlClient();

  const [isResponseCreating, setIsResponseCreating] = useState(false);

  const createResponse = useCallback(async () => {
    if (!currentUser || isResponseCreating || !client) {
      return;
    }

    setIsResponseCreating(true);
    const { createResponse } = await client.createResponse({
      input: {
        answers: responseAnswers,
        formId: form.id,
      },
    });
    const response = createResponse?.response;
    setIsResponseCreating(false);
    if (!response) {
      return;
    }
  }, [client, currentUser, form.id, responseAnswers, isResponseCreating]);

  return {
    isResponseCreating,
    createResponse,
  };
};

type Props = {
  form:
    | DatabaseDetailPageProps["form"]
    | SpecialWelcomeSaihateContentQuery["forms"][number];
  closeModal: () => void;
  setModalClosable: (closable: boolean) => void;
};
export type { Props };
export { useModalContentStep, ModalContentStep, useCreateResponse };
